export interface IProductSpecIterator {
    getItems(): Generator<IProductSpecItem, any, any>;
}

export type MultiUpdaterType =
    | typeof OldProductSpecMultiUpdater
    | typeof VueProductSpecMultiUpdater;

export interface IProductSpecItem {
    shouldAppendToAuctionSocket: boolean;
    auctionSocketId: number;
    getSecondsLeft(): number;
    forced: boolean;
    getRefreshTriggered(): boolean;
    setRefreshTriggered(value: boolean): void;
    update(context: string): Promise<void>;
    shouldQueue: boolean;
    multiUpdaterType: MultiUpdaterType;
    setMarkForUpdate(id: string, stampData: string | null | undefined): void;
    resetMarkForUpdate(): void;
    boundSetMarkForUpdate: (
        id: string,
        stampData: string | null | undefined
    ) => void;
}

export interface IProductSpecMultiUpdater {
    update(specItems: IProductSpecItem[], context: string): Promise<void>;
}

export const apiUrlUpdatedProductListVue = "/ProductList/UpdatedProductSpecs";

export function mapVueItemToUpdatedRequest(item: VueProductSpecItem): any {
    return {
        itemId: item.itemId,
        updated: item.forcedStamp,
        //contextAuctionId: item.contextAuctionId,
    };
}

import { AuctionCountdownTimer } from "./countdown/AuctionCountdownTimer";
import { type OldProductSpecMultiUpdater } from "./spec-iterator/old/OldProductSpecMultiUpdater";
import { type VueProductSpecItem } from "./spec-iterator/vue/VueProductSpecItem";
import { type VueProductSpecMultiUpdater } from "./spec-iterator/vue/VueProductSpecMultiUpdater";

let timer: AuctionCountdownTimer | undefined;

export function create() {
    if (timer != null) return timer;
    return (timer = new AuctionCountdownTimer());
}
